import { MaybeJwtUser } from "@notemeal/shared/ui/utils/tokens";
import { DataAttributes, useIntercom } from "react-use-intercom";
import { IntercomUserFragment, useUserForIntercomQuery } from "../../types";
import { useUser } from "../tokens";

type CustomAttributes = { "Is Staff": boolean; "Org ID": string | undefined; Org: string | undefined; "User Type": string | undefined };

const getCustomAttributes = (token: MaybeJwtUser): CustomAttributes | null => {
  if (token) {
    return {
      "Is Staff": token.isStaff,
      Org: token.orgMembership?.org.name,
      "Org ID": token.orgMembership?.org.id,
      "User Type": token.orgMembership?.roles.join(", "),
    };
  } else {
    return null;
  }
};

const getAttributes = (user: IntercomUserFragment, userHash: string): DataAttributes => {
  return { name: `${user.firstName} ${user.lastName}`, userId: user.id, email: user.email || undefined, userHash };
};

export const useIntercomBoot = async () => {
  const { boot } = useIntercom();
  const user = useUser();

  const attributesFromToken = getCustomAttributes(user);

  useUserForIntercomQuery({
    onCompleted: data => {
      if (user && attributesFromToken) {
        const attributes = getAttributes(data.myUser, data.myIntercomHash);
        boot({ ...attributes, customAttributes: attributesFromToken });
      }
    },
  });
};
